module.exports = __webpack_public_path__ + "img/quest_icon_0040_special.b3d2d980.png";